export default __webpack_public_path__ + "static/media/pattern-tree.156bb943.svg";